import { render } from "./LoginRoute.vue?vue&type=template&id=56ce40ce&scoped=true"
import script from "./LoginRoute.vue?vue&type=script&lang=js"
export * from "./LoginRoute.vue?vue&type=script&lang=js"

import "./LoginRoute.vue?vue&type=style&index=0&id=56ce40ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ce40ce"]])

export default __exports__